<template>
  <div v-if="!cargando">
    <table style="width: 100%;">
      <thead style="background-color: #DCD9D9;" class="imprimir">
        <tr>
          <th v-if="aHeaders[0].detalle !== '0'" scope="col" style="width: 5%;"></th>
          <th v-for="(oHeaders, i) in aHeaders" :key="i" scope="col" :style="`width: ${oHeaders.width}%; text-align: center; ${(oHeaders.visible == '0') ? 'display: none;' : ''}`">
            <h3 class="ntitlesdark--text">{{ oHeaders.text }}</h3>
          </th>
        </tr>
      </thead>
      <tbody v-if="aData.length == 0" class="imprimir">
        <tr>
          <td v-if="aHeaders[0].detalle !== '0'">
            <v-btn icon small disabled
              @click="ViewDetails(`m${sIndicaSeccion}_${aData[0][0].id}_0`)">
              <v-icon v-if="!bIcon">fas fa-caret-right</v-icon>
              <v-icon v-else>fas fa-caret-down</v-icon>
            </v-btn>
          </td>
          <td :colspan="aHeaders.length">
            <span class="font-weight-bold">No hay información</span>
          </td>
        </tr>
      </tbody>
      <tbody v-else v-for="(oData, i) in aData" :key="i" class="imprimir">
        <tr>
          <td v-if="aHeaders[0].detalle !== '0'">
            <v-btn icon small
              @click="ViewDetails(`m${sIndicaSeccion}_${oData[0].id}_${i}`)">
              <v-icon v-if="!bIcon">fas fa-caret-right</v-icon>
              <v-icon v-else>fas fa-caret-down</v-icon>
            </v-btn>
          </td>
          <td v-for="(oDataField, j) in oData" :key="j" :style="`background-color: ${oDataField.color}`">
            <span style="font-size: 15px;">{{ oDataField.text }}</span>
          </td>
        </tr>
        <tr v-if="aHeaders[0].detalle == '1'" :id="`m${sIndicaSeccion}_${oData[0].id}_${i}`" class="for-export" style="display: none;">
          <td :colspan="(aHeaders.length + 1)">
            <GridAnidada
              :sIdParent="oData[0].id"
              :sIdParent2="oData[0].id2"
              :oTablas="oTablas"
              :sIndicaSeccion="`${sIndicaSeccion}`">
            </GridAnidada>
          </td>
        </tr>
        <tr v-else-if="aHeaders[0].detalle == '2'" :id="`m${sIndicaSeccion}_${oData[0].id}_${i}`" class="for-export" style="display: none;">
          <td :colspan="(aHeaders.length + 1)">
            <GridLastLevel
              :sIdParent="`${oData[0].id}`"
              :sTabla="`${oTablas.Three}`">
            </GridLastLevel>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axiosServices from '@/services/axiosServices.js'
import GridAnidada from '@/components/Reportes/Componentes/GridAnidada.vue'
import GridLastLevel from '@/components/Reportes/Componentes/GridLastLevel.vue'
export default {
  props: {
    oTablas: {
      type: Object
    },
    sIndicaSeccion: {
      type: String,
      default: ''
    }
  },
  components: {
    GridAnidada,
    GridLastLevel
  },
  data () {
    return {
      bShow: false,
      bIcon: false,
      aHeaders: [],
      aData: [],
      cargando: true
    }
  },
  mounted () {
    this.getHeaders()
  },
  methods: {
    ViewDetails (sIdIndex) {
      let tblDetail = document.getElementById(`${sIdIndex}`)
      if (tblDetail.style.display === "none") {
        tblDetail.style.display = "table-row";
        // tblDetail.style.border = "1px solid black"
        tblDetail.style["text-align"] = "center";
        this.bIcon = true
      } else {
        tblDetail.style.display = "none";
        // tblDetail.style.border = "1px solid black"
        tblDetail.style["text-align"] = "center";
        this.bIcon = false
      }
    },
    getHeaders () {
      this.cargando = true
      axiosServices.getConfiguration('/InformeRiesgos_headersGrid', true, `sTable=${this.oTablas.Master}&level=primary`).then(aHeaders =>{
        this.aHeaders = aHeaders.aData
        this.getData()
      })
    },
    getData () {
      let sParams = `sTable=${this.oTablas.Master}&level=primary`
      axiosServices.getConfiguration('/InformeRiesgos_DataGrid', true, sParams).then(aDataItems =>{
        this.aData = aDataItems.aData
        this.cargando = false
      })
    }
  },
}
</script>
<style>
  table {
    table-layout: fixed;
  }
  table, td, th {
    border: 1px solid #C8C8C8;
    border-collapse: collapse;
    text-align: center;
    text-align: -webkit-center;
  }
  td {
    word-wrap: break-word; 
  }
</style>